import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { Card, Box, TextField, Typography, Button, Icon, } from '@mui/material';
import Paper from '@mui/material/Paper';
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import ReactApexChart from 'react-apexcharts';
import moment from 'moment';
import { campaignNameSearch, getRecentCampaign } from '../../services/campaigns.service';
import { getCampaignReportsData, getViewershipReportsData } from 'services/reports.service';
import { RootState } from 'Stores/store';
import { ClientReportState } from 'Stores/Slices/clientReportsSlice';
import { useAppSelector } from 'Stores/Hooks/hooks';
import { WidthNormal } from '@mui/icons-material';

const PREFIX = 'ClientReportParent';

const classes = {
	root: `${PREFIX}-root`,
	root1: `${PREFIX}-root1`,
	title: `${PREFIX}-title`,
	cardActionArea: `${PREFIX}-cardActionArea`,
	selectEmpty: `${PREFIX}-selectEmpty`,
	margin: `${PREFIX}-margin`,
	inputTitle: `${PREFIX}-inputTitle`,
	cardbody: `${PREFIX}-cardbody`,
	picdate: `${PREFIX}-picdate`,
	input: `${PREFIX}-input`,
	btnsubmit: `${PREFIX}-btnsubmit`,
	rootoo: `${PREFIX}-rootoo`,
	card1: `${PREFIX}-card1`,
	tbl: `${PREFIX}-tbl`,
	body: `${PREFIX}-body`,
	innerContainer: `${PREFIX}-innerContainer`,
	formcontrol: `${PREFIX}-formcontrol`,
	datepickercontainer: `${PREFIX}-datepickercontainer`,
	paperContainer: `${PREFIX}-paperContainer`,
	paperContainerHeading: `${PREFIX}-paperContainerHeading`,
	campaingReportinput: `${PREFIX}-campaingReportinput`,
	innerdiv: `${PREFIX}-innerdiv`,
	ClientNamelabel: `${PREFIX}-ClientNamelabel`,
	ClientDurationlabel: `${PREFIX}-ClientDurationlabel`,
	selectoption: `${PREFIX}-selectoption`,
	ops: `${PREFIX}-ops`,
	locationAndView: `${PREFIX}-locationAndView`,
	AdCounttxt: `${PREFIX}-AdCounttxt`,
	courtAmount: `${PREFIX}-courtAmount`,
	ds: `${PREFIX}-ds`,
	viewtxt: `${PREFIX}-viewtxt`,
	formElement: `${PREFIX}-formElement`,
};

const Root = styled('div')((
	{
		theme
	}
) => ({
	[`& .${classes.root}`]: {
		flexGrow: 1,
		width: '100%',
		padding:20
	},

	[`& .${classes.root1}`]: {
		maxWidth: 345
	},

	[`& .${classes.title}`]: {
		fontWeight: 700,
		fontSize: 20,
		color: "#000000",
		padding: "24px 24px",
	},

	[`& .${classes.cardActionArea}`]: {
		transition: "box-shadow 0.3s",
		"&:hover": {
			boxShadow: "0px 0px 0px rgba(0, 0, 0, 0.2)"
		}
	},

	[`& .${classes.selectEmpty}`]: {
		marginTop: theme.spacing(2),
	},

	[`& .${classes.margin}`]: {
		margin: theme.spacing(1),
	},

	[`& .${classes.inputTitle}`]: {
		fontSize: 27,
		color: "#287eff",
		fontWeight: 600,
		backgroundColor: "#f4f4f4",
		padding: "0px 7px",
		margin: "0px 5px",
		'&:hover $label': {
			backgroundColor: "#000",
		}
	},

	[`& .${classes.cardbody}`]: {
		border: "none",
		boxShadow: "none",
		backgroundColor: "#f4f4f4",
		marginBottom: "24px",
		"&:hover": {
			borderRadius: 18,
			boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.3)",
			backgroundColor: "#fff",

			[`& .${classes.ClientNamelabel}`]: {
			backgroundColor: "#fff",
			},
			[`& .${classes.selectoption}`]: {
					backgroundColor: "#fff",
			},
			[`& .${classes.input}`]: {
				backgroundColor: "#fff",
			},
		},
	},

	[`& .${classes.picdate}`]: {
		width: "1300px",
		padding: "30px",
		fontSize: "20px",
		backgroundColor: "#ffffff",
	},

	[`& .${classes.input}`]: {
		backgroundColor: "#f4f4f4",
		border: "1px solid #DEE2E6",
		borderRadius: "14px",
		width: "1300px",
		padding: "20px",
		fontSize: "20px",
	},

	[`& .${classes.btnsubmit}`]: {
		color: "#ffffff",
		backgroundColor: "#287eff",
		fontSize: "14px",
		marginTop: "60px",
		padding: "6px 12px",
		borderRadius: "8px"
	},

	[`& .${classes.rootoo}`]: {
		gap: "20px",
		display: 'flex',
	},

	[`& .${classes.card1}`]: {
		borderRadius: "20px",
		textAlign: "center",
		height: "170px",
		width: "200px",
	},

	[`& .${classes.tbl}`]: {
		overflowY: "hidden"
	},

	[`& .${classes.body}`]: {
		display: "block",
		overflow: "auto",
		height: "300px"
	},

	[`& .${classes.innerContainer}`]: {
		display: "flex",
		justifyContent: "space-between",
	},

	[`& .${classes.formcontrol}`]: {
		width: "100%",
		margin: theme.spacing(1),
		minWidth: 120,

	},

	[`& .${classes.datepickercontainer}`]: {
		display: "flex",
		justifyContent: "center",
		marginTop: "16px",
		padding: "24px 24px",
	},

	[`& .${classes.paperContainer}`]: {
		backgroundColor: "#004AC0",
		borderTopRightRadius: "20px",
		borderTopLeftRadius: "20px",
		height: "40%",
		padding: "24px 24px",
	},

	[`& .${classes.paperContainerHeading}`]: {
		fontSize: "18px",
		color: "#ffffff"

	},

	[`& .${classes.campaingReportinput}`]: {
		display: "flex",
		justifyContent: "space-between",
		flexDirection: "column",
		gap: "20px",
		margin: "0px 10px"
	},

	[`& .${classes.innerdiv}`]: {
		display: "flex",
		flexDirection: "column",
		border: "1px solid #CCCCCC",
		width: "100%",
		borderRadius: "10px",
		height: "60px",
		"&:hover": {
			border: "1px solid #113cfc",
		},
		"&:focus-within": {
			border: "1px solid #113cfc",
			boxShadow: "0px 0px 10px rgba(0,0,0,0.1)"
		},

	},

	[`& .${classes.ClientNamelabel}`]: {
		marginTop: "-10px",
		fontWeight: 600,
		color: "#287eff",
		backgroundColor: "#f4f4f4",
		padding: "0px 0px 0px 5px",
		marginLeft: "10px",
		fontSize: "16px",
		width: "150px",
		'&: hover': {
			background: "#fff",
		}
	},

	[`& .${classes.ClientDurationlabel}`]: {
		marginTop: "-10px",
		fontWeight: 600,
		color: "#287eff",
		backgroundColor: "#f4f4f4",
		padding: "0px 0px 0px 5px",
		marginLeft: "10px",
		fontSize: "16px",
		width: "90px",
		'&: hover': {
			background: "#fff",
		}
	},

	[`& .${classes.selectoption}`]: {
		fontSize: "17px",
		border: "none",
		padding: "0px 20px",
		margin: "2px 0px",
		backgroundColor: "#f4f4f4",
		borderColor: "#f4f4f4",
		color: "#287eff",
		outline: "none",
		'&:hover': {
			backgroundColor: "#fff",
		},
	},

	[`& .${classes.ops}`]: {
		fontSize: "17px",
		"&:hover": {
			backgroundColor: "#000",
		}
	},

	[`& .${classes.locationAndView}`]: { fontSize: "17px", color: "#868e96"},

	[`& .${classes.AdCounttxt}`]: {
		backgroundColor: "#001F84",
		borderTopRightRadius: "20px",
		borderTopLeftRadius: "20px",
		height: "40%",
		padding: "24px 24px",
	},

	[`& .${classes.courtAmount}`]: {
		textAlign: "center",
		padding: "24px"
	},

	[`& .${classes.ds}`]: {
		textAlign: "center",
		padding: "24px"
	},

	[`& .${classes.viewtxt}`]: {
		color: "#000000",
		fontWeight: 600,
    marginLeft:'20px'
	},

	[`& .${classes.formElement}`]: {
        width: '150px',
		marginLeft: '40px'
    },
}));

function TabPanel(props: any) {
	const { children, value, index, ...other } = props;

	return (
		<Root
			role="tabpanel"
			hidden={value !== index}
			id={`scrollable-auto-tabpanel-${index}`}
			aria-labelledby={`scrollable-auto-tab-${index}`}
			{...other}>
			{value === index && (
				<Box p={3}>
					<Typography>{children}</Typography>
				</Box>
			)}
		</Root>
	);
}

const LineChart = (props: any) => {
  const clientReportStore: ClientReportState = useAppSelector(
		(state: RootState) => state.clientReports,
	);

  const { isSidebarCollapsed } = clientReportStore
  console.log('isSidebarCollapsed',isSidebarCollapsed)

	const [digram, setDigram] = useState<any>();
	const campId = props.campId
	const linegraph = async (campId: number) => {
		try {
			const linedigram = await getViewershipReportsData(campId);
			setDigram(linedigram)
		}
		catch (err) {
			console.log("error");
		}
	}
	useEffect(() => {
		linegraph(campId)
	}, [campId])

	const { width, height } = window.screen;
	const [chartOptions, setChartOptions] = useState<any>({
		series: [{
			name: 'Sales',
			data: [],
		}],
		stroke: {
			show: true,
			curve: 'smooth',
			lineCap: 'butt',
			colors: undefined,
			width: 2,
			dashArray: 0,
		},
		options: {
			chart: {
				id: 'line-chart',
				type: 'line',
				width: 80,
				height: 60,
				toolbar: {
					tools: {
						download: true,
						selection: false,
						zoom: false,
						zoomin: false,
						zoomout: false,
						pan: false,
						reset: false
					}
				}
			},
			xaxis: {
				categories: [
					"15/05",
					"14/05",
					"13/05",
					"12/05",
					"11/05",
					"10/05",
					"09/05",
					"08/05",
					"07/05",
					"06/05",
					"05/05",
					"04/05",
					"03/05",
					"02/05",
					"01/05",
					"30/04",
					"29/04",
					"28/04",
					"27/04",
					"26/04",
					"25/04",
					"24/04",
					"23/04",
					"22/04",
					"21/04",
					"20/04",
					"19/04",
					"18/04",
					"17/04"
				],
				title: {
					text: 'No of Screens'
				}
			},
			yaxis: {
				yaxis: {
					tickAmount: 2
				},
				title: {
					text: 'No of Views',
				}
			},
			grid: {
				xaxis: {
					lines: {
						show: true
					}
				}
			},
		}
	});
	useEffect(() => {
		if (digram) {
			console.log("chartOptions.series[0].data", chartOptions.series[0].data = [0, 0, 0, 0]);
		}
	}, [digram]);

  console.log("Width==========================>",isSidebarCollapsed ? (width/1.15) :width);
  console.log("props.isSidebarCollapsed, props.isSidebarCollapsed", isSidebarCollapsed);

	return (
		<div style={{ margin: "40px" ,justifyContent:'center'}}>
			<Typography
				className={classes.viewtxt}
			>VIEWS</Typography>
			<ReactApexChart
				options={{
					chart: {
						id: 'line-chart',
						type: 'line',
						width: 80,
						height: 60,
						toolbar: {
							tools: {
								download: true,
								selection: false,
								zoom: false,
								zoomin: false,
								zoomout: false,
								pan: false,
								reset: false
							}
						}
					},
					xaxis: {
						categories: digram?.dateArray,
						title: {
							text: 'No of Screens',
							style: {
								fontSize: '14px',
								fontWeight: 600,
								color: '#333',
							}
						}
					},
					yaxis: {

						title: {
							text: 'No of Views',
							style: {
								fontSize: '14px',
								fontWeight: 600,
								color: '#333',
							}
						}
					},
					grid: {
						xaxis: {
							lines: {
								show: true
							}
						}
					},
				}}
				series={[{ name: 'Sales', data: digram?.actualViewershipArray }]}
				type="line"
				height={550}
        width={isSidebarCollapsed ? (width/1.2) :(width/1.4)}
				onRender={linegraph}
			/>
		</div>
	)
}

interface MyComponentProps {
	apiFunction: (api: string) => Promise<any>;
	focusApiFunction: any;

}

function ClientReportParentRainbow(props: MyComponentProps) {
  const clientReportStore: ClientReportState = useAppSelector(
		(state: RootState) => state.clientReports,
	);

  const { isSidebarCollapsed } = clientReportStore


	const [campId, setCampId] = useState()
	const [selectedCampaignOption, setSelectedCampaignOption] = useState('');
	const [selectedCampaignDurationOption, setSelectedCampaignDurationOption] = useState('');
	const [campaignNames, setCampaignNames] = useState<any>([{
		campaignName: 'Rainbow Hospitals Campaign'
	}]);
	const [campaignDurations, setCampaignDurations] = useState<any>([
		{
			duration: 'August'
		},
		{
			duration: 'September [1 - 15]'
		},
		{
			duration: 'September [16 - 24]'
		}
	]);
	const [selectDate, setSelectDate] = useState<any>([]);
	const [getCampaignData, setGetCampaignData] = useState<any>([]);
	const apicalltry = async () => {
		try {
			const data = await getRecentCampaign()
			setCampaignNames(data)
		}
		catch (err) {
			console.log("error");
		}
	}

	const columns = [
		{ label: "LOCATION" },
		{ label: "NO.OF VIEWS" },
	];

	const onCampaignChange = (value: any) => {
		setSelectedCampaignOption(value);
	}

	const onCampaignDurationChange = (value: any) => {
		setSelectedCampaignDurationOption(value);
	}

	const downloadReport = () => {
		let downloadLink = 'https://static-bellplusmedia.s3.ap-south-1.amazonaws.com/reports/Rainbow+Hospitals+August+Log+Reports.zip';
		if(selectedCampaignDurationOption === 'September [1 - 15]'){
			downloadLink = 'https://static-bellplusmedia.s3.ap-south-1.amazonaws.com/reports/Rainbow+Hospitals+September+(01-10-2023+to+15-10-2023)+Log+Reports.zip';
		} else if(selectedCampaignDurationOption === 'September [16 - 24]'){
			downloadLink = 'https://static-bellplusmedia.s3.ap-south-1.amazonaws.com/reports/Rainbow+Hospitals+September+(16-10-2023+to+24-10-2023)+Log+Reports.zip';
		}
		window.open(downloadLink, '_blank');
	}

	// const handleOnChange = async (value: any) => {
	// 	const selectOneOption = value;
	// 	setSelectedOption(selectOneOption);
	// 	if (selectOneOption) {
	// 		const chart = await campaignNameSearch(selectOneOption)
	// 		setCampId(chart[0].id)
	// 		setSelectDate(chart)

	// 		const sendPayload = {
	// 			"campaignId": chart[0].id,
	// 			"startDate": chart[0]?.campaignAdvertisementDetailsResponse[0]?.startDate,
	// 			"endDate": chart[0]?.campaignAdvertisementDetailsResponse[0]?.startDate,
	// 		}
	// 		const lineChartData = await getCampaignReportsData(sendPayload);

	// 		setGetCampaignData(lineChartData)
	// 	}
	// }
	// useEffect(() => {
	// 	apicalltry()
	// }, []);

	// useEffect(() => {
	// 	if (campaignNames.length > 0) {
	// 		handleOnChange(campaignNames[0].campaignName)
	// 	}
	// }, [campaignNames]);

	return (
		<Root>
			<div className={classes.root} >
				<Card className={classes.cardbody}>
					<div>
						<Typography variant="h5" className={classes.title}>
							Campaign Reports
						</Typography>
					</div>
					<div style={{ padding: "24px 24px" }}>
						<div className={classes.campaingReportinput}>
							<div className={classes.innerdiv}>
								<label className={classes.ClientNamelabel}>Campaign Name:</label>
								<select id="campaign-name"
									className={classes.selectoption}
									onChange={(e) => onCampaignChange(e.target.value)}
								>
									{campaignNames.map((data: any, index: any) => {
										return (
											<option key={index}
												className={classes.ops}
												value={data.campaignName}
											>{data.campaignName}</option>
										)
									})}
								</select>
							</div>
							<div className={classes.innerdiv}>
								<label className={classes.ClientDurationlabel}>Duration:</label>
								<select id="campaign-duration"
									className={classes.selectoption}
									onChange={(e) => onCampaignDurationChange(e.target.value)}
								>
									{campaignDurations.map((data: any, index: any) => {
										return (
											<option key={index}
												className={classes.ops}
												value={data.duration}
											>{data.duration}</option>
										)
									})}
								</select>
							</div>
						</div>
						{/* <div className={classes.datepickercontainer}>
							<span className={classes.input}>
								{moment(selectDate[0]?.campaignAdvertisementDetailsResponse[0]?.startDate).format('MM/DD/YYYY')}
								{" ~ "}
								{moment(selectDate[0]?.campaignAdvertisementDetailsResponse[0]?.endDate).format('MM/DD/YYYY')}
							</span>
						</div> */}
						{/* <Button
						variant="contained"
						className={classes.btnsubmit}>
						Submit
					</Button> */}

					</div>
				</Card>
				<div className={classes.rootoo}>
					<Button
                    className={classes.formElement}
                    style={{ backgroundColor: '#e0e0e0' , color:'rgba(0, 0, 0, 0.87)' }}
                    variant="contained"
                    type="button"
					onClick={downloadReport}
                    endIcon={<Icon>download</Icon>}>Download</Button>
				</div>
				{/* <div className={classes.rootoo}>
					<Box display="flex" justifyContent="center" alignItems="center">
						<Paper elevation={3} style={{ borderRadius: "20px"}}>
							<div className={classes.card1} style={{width: isSidebarCollapsed ? '250px' : '200px' }}>
								<div className={classes.AdCounttxt}>
									<span className={classes.paperContainerHeading} > Ad Play Count </span></div>
								<div className={classes.courtAmount}><span style={{ fontSize: "28px" }}>1.45M </span></div>
							</div>
						</Paper>
					</Box>
					<Box display="flex" justifyContent="center" alignItems="center">
						<Paper elevation={3} style={{ borderRadius: "20px" }}>
							<div className={classes.card1} style={{width: isSidebarCollapsed ? '250px' : '200px' }}>
								<div className={classes.paperContainer}>
									<span className={classes.paperContainerHeading}>Campaign Name</span></div>
								<div className={classes.ds}><span style={{ fontSize: "28px" }}>DS</span></div>
							</div>
						</Paper>
					</Box>
					<Box display="flex" justifyContent="center" alignItems="center">
						<Paper elevation={3} style={{ borderRadius: "20px" }}>
							<div className={classes.card1} style={{width: isSidebarCollapsed ? '250px' : '200px' }}>
								<div className={classes.AdCounttxt}>
									<span className={classes.paperContainerHeading} >Total Screens</span></div>
								<div className={classes.ds}><span style={{ fontSize: "28px" }}> 1506 </span></div>
							</div>
						</Paper>
					</Box>
					<Box sx={{
						boxShadow: "0px 0px 10px rgba(0,0,0,0.3)",
						maxHeight: '170px',
						overflow: 'auto',
						maxWidth: "770px",
						borderRadius: "20px"
					}}>
						<Table
							stickyHeader aria-label="sticky table"
              				style={{width: isSidebarCollapsed ? '600px' : '550px' }}
              			>
							<TableHead>
								<TableRow style={{ backgroundColor: "#E1E2E4" }}>
									{columns.map((column) => (
										<TableCell style={{ fontSize: "15px", padding:'20px' }}>
											{column.label}
										</TableCell>
									))}
								</TableRow>
							</TableHead>
							{getCampaignData.map((campaignData: any) => (
								<TableRow>
									<TableCell
										className={classes.locationAndView}
									>{campaignData.LocationName}
									</TableCell>
									<TableCell
										className={classes.locationAndView}
									>{campaignData.Viewership}
									</TableCell>
								</TableRow>
							))}
						</Table>
					</Box>
				</div>
				<LineChart campId={campId} /> */}

			</div>
		</Root>
	);
}

export default ClientReportParentRainbow;
